<div class="img-container clickable">
  <a [routerLink]="(game.launchUrl && game.enabled !== false && game.disabledByPromo !== true ? '/play/' : '/details/') + game.slug">
    <img class="img-fluid rounded" [ngClass]="{'disabled-game': game.enabled === false || game.disabledByPromo}"
         [src]="game.getImage('512x512')" alt="{{game.name}}" (error)="updateNotFoundImgUrl($event)"
         loading="lazy">
  </a>

  <div class="badge bg-primary-subtle rounded-pill game-label" *ngIf="game.category">{{ game.category }} </div>

  <div *ngIf="game.tag && (game.tag.includes('beta') || game.tag.toLowerCase().includes('prelaunch'))" class="flag d-flex flex-row align-items-center">
    <img src="assets/icons/beta_sign.svg" alt="beta sign">
    <small class="ms-1">BETA</small>
  </div>

  <app-like-label [game]="game" [favouriteGameIds]="favouriteIds"></app-like-label>

</div>
